import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import { t } from '../../common/i18n/index.js';

import './ApproveOrDeny.scss';

export type ApproveOrDenyProps = {
  isSaving?: boolean;
  approveButtonLabel?: string;
  denyButtonLabel?: string;

  onApprove: () => void;
  onDeny: () => void;
};

export const ApproveOrDeny = ({
  isSaving,
  approveButtonLabel,
  denyButtonLabel,
  onApprove,
  onDeny,
}: ApproveOrDenyProps) => {
  return (
    <div className="of-approve-or-deny">
      <CL.Button id="approve-order-button" size="l" loading={isSaving} onClick={onApprove}>
        {approveButtonLabel || t.P5RQ('Accept')}
      </CL.Button>
      <CL.Button
        color="light"
        size="l"
        id="reject-order-button"
        disabled={isSaving || false}
        className={dsClass.MARGIN_RIGHT_3}
        onClick={onDeny}
      >
        {denyButtonLabel || t.ONSX('Reject')}
      </CL.Button>
    </div>
  );
};
